
export enum ReportTranslate {
  MAIN_ENTITY = 'mainEntity',
  SUB_ENTITY = 'subEntity',
  MAIN_COLUMNS= 'mainColumns',
  SUB_COLUMNS = 'subColumns',
  RESULT_COLUMNS = 'resultColumns',
  FILTER_CRITERIA = 'criteriaColumns'
}

export namespace ReportTranslate {

  /**
   * Returns an array of all values that the different types are set to
   * (i.e SuaStatusType.SENT will return the value 'Skickad').
   * @returns {Array<String>} Array of the type's string value.
   */
  export function getValues(): Array<String> {
    return [ 
      ReportTranslate.MAIN_ENTITY,
      ReportTranslate.SUB_ENTITY,
      ReportTranslate.MAIN_COLUMNS,
      ReportTranslate.SUB_COLUMNS,
      ReportTranslate.RESULT_COLUMNS,
      ReportTranslate.FILTER_CRITERIA
    ]
  }
}